import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  static values = {
    lines: Number,
    moreText: { type: String, default: "Zobraziť viac" },
    lessText: { type: String, default: "Zobraziť menej" },
  }

  connect() {
    this.expanded = false

    this.lineHeight = this.getLineHeight()
    this.collapsedHeight = this.lineHeight * this.linesValue

    this.fullHeight = this.contentTarget.scrollHeight

    if (this.fullHeight <= this.collapsedHeight) {
      return
    }

    this.contentTarget.style.maxHeight = `${this.collapsedHeight}px`
    this.contentTarget.classList.add("show-more-fade")

    this.buttonTarget.classList.remove("hidden")
    this.buttonTarget.textContent = this.moreTextValue
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.contentTarget.style.maxHeight = `${this.fullHeight}px`
      this.buttonTarget.textContent = this.lessTextValue
      this.contentTarget.classList.remove("show-more-fade")
    } else {
      this.contentTarget.style.maxHeight = `${this.collapsedHeight}px`
      this.buttonTarget.textContent = this.moreTextValue
      this.contentTarget.classList.add("show-more-fade")
    }
  }

  getLineHeight() {
    const style = window.getComputedStyle(this.contentTarget)
    let lineHeight = parseFloat(style.lineHeight)

    if (isNaN(lineHeight)) {
      lineHeight = parseFloat(style.fontSize) * 1.4
    }

    return lineHeight
  }
}
